import React from 'react';
import PropTypes from 'prop-types';

import FilledButton from 'components/Buttons/FilledButton';
import If from 'components/If';
import ModalContainer from 'components/ModalContainer';

import { totallyHours, formatDate, formatHour } from 'utils/moment';

import * as S from './styles';

const AppointmentsHistory = ({
  date,
  allHours,
  workedHours,
  isVisible,
  setIsVisible,
}) => (
  <ModalContainer
    headText="Informações do apontamento"
    isOpen={isVisible}
    setIsOpen={setIsVisible}
  >
    <S.HistoryTitle>{`Histórico - ${formatDate(date)}`}</S.HistoryTitle>
    <S.History>
      <If condition={!(allHours.length % 2 === 0)}>
        <S.OddHours>(Existem batidas ímpares)</S.OddHours>
      </If>

      {allHours.map((day, index) => (
        <React.Fragment key={index}>
          <If condition={index % 2 === 0}>
            <S.HistoryItem>
              <span>Entrou</span>
              às
              <span>{formatHour(day)}</span>
            </S.HistoryItem>
          </If>

          <If condition={index % 2 !== 0}>
            <S.HistoryItem>
              <span>Saiu</span>
              às
              <span>{formatHour(day)}</span>
            </S.HistoryItem>
          </If>
        </React.Fragment>
      ))}

      <S.HistoryTotally>
        <S.TotallyFeatured>Horas trabalhadas:</S.TotallyFeatured>
        <S.TotallyHours>{`${totallyHours(workedHours)}`}</S.TotallyHours>
      </S.HistoryTotally>

      <S.HistoryActions>
        <FilledButton text="Ok" handleClick={() => setIsVisible(false)} />
      </S.HistoryActions>
    </S.History>
  </ModalContainer>
);

export default AppointmentsHistory;

AppointmentsHistory.defaultProps = {
  isVisible: true,
};

AppointmentsHistory.propTypes = {
  date: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string])
    .isRequired,
  allHours: PropTypes.arrayOf(PropTypes.string).isRequired,
  workedHours: PropTypes.number.isRequired,
  isVisible: PropTypes.bool,
  setIsVisible: PropTypes.func.isRequired,
};
